export const scipPreferencesRoutes = {
  echaProfileSetup: 'echa-profile-setup',
  dossierDefaults: 'dossier-defaults'
};
